<template>
  <div class="panels-item">
    <div
      class="card"
      :class="{'card-sm' : sm, 'clickable' : panel.content}"
      v-on:click="panel.content ? $refs.panelModal.show() : null"
    >
      <img
        :src="imgAsset"
        class="card-img-top"
        :alt="panel.title"
        v-if="panel.description.image"
      />
      <div class="card-body">
        <h4 class="card-title">{{panel.title}}</h4>
        <div class="card-icons" v-if="panel.description.icons">
          <IconItem v-for="item in panel.description.icons" :item="item" :key="item.index" />
        </div>
        <p
          class="card-text mt-1"
          v-if="panel.description.text"
          :class="{'d-none d-sm-block' : panel.content}"
        >{{panel.description.text}}</p>
      </div>
    </div>
    <Modal
      v-if="panel.content"
      ref="panelModal"
      :title="panel.title"
      :sm="!(panel.content.image)"
    >
      <PanelsModalContent :image="panel.content.image" :icons="panel.content.icons" :links="panel.content.links" :containImage="containImage">{{panel.content.text}}</PanelsModalContent>
    </Modal>
  </div>
</template>

<script>
import Modal from "./Modal";
import IconItem from "./IconItem";
import PanelsModalContent from "./PanelsModalContent";

export default {
  name: "PanelsItem",
  components: {
    Modal,
    IconItem,
    PanelsModalContent
  },
  props: {
    panel: {
      type: Object,
      required: true
    },
    sm: {
      type: Boolean,
      required: false,
      default: false
    },
    containImage: {
      type: Boolean,
      required: false,
    }
  },
  computed: {
    imgAsset: function() {
      if (this.panel.description.image) {
        return require(`@/assets/img/${this.panel.description.image}`)
      } else {
        return "";
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/styles/_variables";
.panels-item {
  //width: 18rem;
  //display: inline-block;
  display: inline-flex;
  vertical-align: top;
  white-space: pre-wrap;
  //max-width: 25rem;
  //flex-grow: 1;

  @media (min-width: map-get($grid-breakpoints,"xl")) {
    flex: 0 0 22rem;
    max-width: calc(100vw - 2rem);
  }

  border: none;

  .card {
    width: 100%;
    border: 1px solid $border-color;

    @media (prefers-color-scheme: dark) {
      border-color: $border-color-darkmode;
      background-color: $body-bg-darkmode;
      color: $body-color-darkmode;
    }

    &:first-child {
      //margin-left: 1rem;

      @media (min-width: 576px) {
        //margin-left: 2rem;
      }
    }

    &:last-child {
      &:after {
        content: "";
        display: inline-block;
        position: absolute;
        width: 1rem;
        left: 100%;
        height: 1px;

        @media (min-width: 576px) {
          width: 2rem;
        }
      }
    }

    &.clickable {
      cursor: pointer;

      &:hover {
        border-color: $gray-700;

        @media (prefers-color-scheme: dark) {
          border-color: $gray-300;
        }
      }
    }
  }

  + .panels-item .card {
    //margin-left: 0.5rem;
  }
}

.card-img-top {
  height: 4rem;
  object-fit: cover;
  border-bottom: 1px solid $border-color;

  @media (prefers-color-scheme: dark) {
    border-color: $border-color-darkmode;
    background-color: $body-bg-darkmode;
    color: $body-color-darkmode;
  }
}

.card-sm {
  flex-direction: row;
  flex-wrap: nowrap;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;

  .card-title {
    font-size: 1rem;
    margin-bottom: 0.25rem;
  }
  .card-img-top {
    width: 3.5rem;
    height: 3.5rem;
    //display: inline-block;
    //border-top-left-radius: calc(0.25rem - 1px);
    //border-bottom-left-radius: calc(0.25rem - 1px);
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom-width: 0;
    border-right: 1px solid $border-color;

    @media (prefers-color-scheme: dark) {
      border-color: $border-color-darkmode;
    }
  }
  .card-body {
    padding: 0.3rem 0.6rem;
    //display: inline-block;
  }
}
</style>
